/**
 * Рубли, как их набрал человек, в целые копейки.
 *
 * Прецедент — parseKopecks на экране спора: та же нормализация (пробелы,
 * запятая как разделитель) и то же Math.round(value * 100). Возвращает null,
 * если строка не является положительной суммой максимум с двумя знаками после
 * разделителя, — вызывающая сторона показывает свою ошибку.
 */
export function rublesToKopecks(raw: string): number | null {
  const normalized = raw.trim().replace(/\s/g, "").replace(",", ".");
  if (!/^\d+(\.\d{1,2})?$/.test(normalized)) return null;
  const value = Number(normalized);
  if (!Number.isFinite(value) || value <= 0) return null;
  return Math.round(value * 100);
}
